import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export abstract class GenericAbsService<T> {

    private BASE_URL: string;

    constructor(private baseUrl: string, private httpClient: HttpClient) {
        this.BASE_URL = baseUrl;
    }

    protected post(endpoint: string, item: any, headers?: HttpHeaders) {
        return this.httpClient
            .post<T>(this.BASE_URL + endpoint, item, { headers });
    }

    protected put(endpoint: string, item: any, headers?: HttpHeaders) {
        return this.httpClient
            .put<T>(this.BASE_URL + endpoint, item, { headers });
    }

    protected getById(endpoint: string, id: any, headers?: HttpHeaders) {
        let url = this.BASE_URL + endpoint;
        if (id) {
            url = `${url}/${id}`;
        }
        return this.httpClient
            .get<T>(url, { headers });
    }

    protected getAll(endpoint: string, headers?: HttpHeaders) {
        return this.httpClient
            .get<T>(`${this.BASE_URL + endpoint}`, { headers });
    }

    protected getByParams(endpoint: string, queryParamsMap: Map<string, any> | null, headers?: HttpHeaders) {
        return this.httpClient
            .get<T>(`${this.BASE_URL + endpoint}?${QueryParams.toQueryString(queryParamsMap)}`, { headers });
    }

    protected delete(endpoint: string, id?: number, headers?: HttpHeaders) {
        let url = this.BASE_URL + endpoint;
        if (id) {
            url = `${url}/${id}`;
        }
        return this.httpClient
            .delete<T>(url, { headers });
    }

}


export class QueryParams {

    static toQueryString(queryParamsMap: Map<string, any> | null) {
        let queryString = '';

        if (queryParamsMap == null) {
            return queryString;
        }

        queryParamsMap.forEach((value: any, key: string) => {
            queryString = queryString.concat(`${key}=${value}&`);
        });
        return queryString.substring(0, queryString.length - 1);
    }
}

